<template>
  <div class="page_table_area permission">
    <!-- 标题 -->
    <div class="table_title_area">
      <div class="left">
        合计：<span class="blue">{{ total }}条</span>
      </div>
      <el-button class="btn_create right" @click="btnCreateClick" v-if="pms.create">
        <div class="btn_content">
          <div class="icon-create"></div>
          <div class="text_create">新建</div>
        </div>
      </el-button>
    </div>
    <!-- 表格 -->
    <div class="table_area">
      <el-table :data="appInfos">
        <el-table-column :width="10 * docFontSize"></el-table-column>
        <el-table-column
          label="创建日期"
          prop="createTime"
          :width="15.4 * docFontSize"
        >
        <!-- <template slot-scope="scope">
          {{ scope.row.createTime | filterCreateDate}}
        </template> -->
        </el-table-column>
        <el-table-column
          label="APP标识"
          prop="appCode"
        ></el-table-column>
        <el-table-column
          label="APP名称"
          prop="appName"
        ></el-table-column>
        <el-table-column
          label="APP说明"
          prop="appDesc"
        ></el-table-column>
        <el-table-column
          label="APP版本"
          prop="appVersion"
        ></el-table-column>
        <el-table-column
          label="下载地址"
          prop="downloadUrl"
        ></el-table-column>
        <el-table-column
          label="强制更新"
          prop="updateFlag"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.updateFlag == 1">是</div>
            <div v-else style="color:#B5B5B5;">否</div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="btnEditClick(scope.row)"  v-if="pms.edit && scope.row.createTime">编辑</el-button>
            <el-button type="text" @click="btnDelClick(scope.row.id)"  v-if="pms.del && scope.row.createTime">删除</el-button>
          </template>
        </el-table-column>
       <template slot="empty">
         <table-empty></table-empty>
       </template>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="pagination_area">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pageNum"
        :page-sizes="[20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 新建 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form :model="appInfo" :rules="rules" ref="appForm">
        <el-form-item label="APP名称" :label-width="formLabelWidth" prop="appName">
          <el-input v-model="appInfo.appName" autocomplete="on"></el-input>
        </el-form-item>
        <el-form-item label="APP标识" :label-width="formLabelWidth" prop="appCode">
          <el-input v-model="appInfo.appCode" autocomplete="on"></el-input>
        </el-form-item>
        <el-form-item label="APP版本" :label-width="formLabelWidth" prop="appVersion">
          <el-input v-model="appInfo.appVersion" autocomplete="on"></el-input>
        </el-form-item>
        <el-form-item label="强制更新" :label-width="formLabelWidth" prop="updateFlag">
          <el-radio v-model="appInfo.updateFlag" :label="1">是</el-radio>
          <el-radio v-model="appInfo.updateFlag" :label="0">否</el-radio>
        </el-form-item>
        <el-form-item label="APP说明" :label-width="formLabelWidth" prop="appDesc">
          <el-input type="textarea" v-model="appInfo.appDesc" autocomplete="on"></el-input>
        </el-form-item>
        <el-form-item label="上传APP包" :label-width="formLabelWidth" prop="fileList" ref="upload">
          <el-upload
            class="upload-demo"
            ref="uploadFile"
            name="appFile"
            :data="{data:JSON.stringify(this.appInfo)}"
            accept=".apk"
            :action="uploadUrl"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :on-change="handleChange"
            :on-success="handleUploadSuccess"
            :file-list="appInfo.fileList"
            :auto-upload="false"
            :multiple="false"
            :limit="1"
            >
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            <div slot="tip" class="el-upload__tip">只能上传apk文件，且不超过600MB</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitUpload('appForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TableEmpty from '../../../../components/TableEmpty.vue';
import mixins from "./Mixins";
import {list, add, getDetails, update, remove} from "@/api/App/index.js";
import Service from '@/utils/fetch';
import _ from "lodash";
export default {
  components: { TableEmpty },
  mixins: [mixins],
  data() {
    return {
      pms:{
        create:false,
        edit:false,
        del:false,
      },
      pageNum: 1,
      pageSize: 20,
      total: 0,
      appInfo:{
        id: null,
        appCode: 'zgjs',
        appName: '中广家书',
        appDesc: '',
        appVersion: '',
        updateFlag: 0,
        fileList: [],
      },
      appInfos: [],
      dialogFormVisible: false,
      title: '',
      formLabelWidth: '120px',
      uploadUrl: Service.defaults.baseURL + '/appInfos/upload',
      rules: {
          appName: [
            { required: true, message: '请输入APP名称', trigger: 'blur' },
            { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
          ],
          appCode: [
            { required: true, message: '请输入APP标识', trigger: 'blur' },
            { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' }
          ],
          appVersion: [
            { required: true, message: '请输入APP版本', trigger: 'blur' },
            { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' }
          ],
          appDesc: [
            { max: 200, message: '长度在200个字符之内', trigger: 'blur' }
          ],
          fileList: [
            { required: true, message: '请选择包文件', trigger: 'submit' }
          ],
          updateFlag: [
            { required: true, message: '请选择是否强制更新', trigger: 'blur' }
          ],
        }
    };
  },
  filters:{
    filterCreateDate(v){
      if(v && v.indexOf(" ") >= 0) {
        return v.split(" ")[0];
      } else {
        return ""
      }
    },
    remarkLength(v) {
      if(v) {
        return v.length;
      } else {
        return 0
      }
    }
  },
  created(){
    let pms = JSON.parse(window.sessionStorage.getItem("binyi_cms_pms"))
    this.pms.create = pms["80100"].check;
    this.pms.edit = pms["80200"].check;
    this.pms.del = pms["80300"].check;
    
  },
  mounted() {
    this.getList();
  },

  methods: {
    btnCreateClick() {
      this.clear();
      this.$nextTick(() => {
        this.$refs['appForm'].clearValidate();
      });
      this.getPmsList_A();
      this.title = "新建APP";
      this.dialogFormVisible = true;
    },
    async getList(){
      const resp = await list(this.pageNum, this.pageSize);
      if(resp.status === 1000){ //成功
        this.appInfos = resp.data.records;
        this.total = resp.data.total;
      }else{
        this.$message.error(resp.message);
      }
    },
    delete(id){
      remove(id);
    },
    async btnEditClick(row) {
      const resp = await getDetails(row.id);
      this.title = "编辑APP";
      this.clear();
      this.$nextTick(() => {
        this.$refs['appForm'].clearValidate();
      });
      
      if(resp.status === 1000){//成功
        this.appInfo = resp.data;
        this.getPmsList_A(row.id);
        this.dialogFormVisible = true;
      }
      
    },
    btnDelClick(id) {
       this.$confirm('此操作将删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const resp = await remove(id);
          console.log(resp)
          if(resp.status === 1000){// 成功
            this.getList();
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          }else{ // 失败
            this.$message({
              type: 'error',
              message: resp.message
            });      
          }
          
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      this.getPmsList_A(id);
    },
    handleSizeChange() {
      this.getList();
    },
    handleCurrentChange() {
      this.getList();
    },
    submitUpload(formName) {
      if(this.appInfo.fileList && this.appInfo.fileList.length > 0){
        _.unset(this.rules, ["fileList"]); // 取消验证上传文件
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$refs.uploadFile.submit();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleRemove(file, fileList) {
      this.appInfo.fileList = fileList;
      this.$refs.appForm.validateField("fileList")
    },
    handlePreview(file) {
      console.log(file);
    },
    handleChange(file, fileList){
      this.appInfo.fileList = fileList;
      if(fileList.length > 0){
        this.$refs.upload.clearValidate();
      }
    },
    handleUploadSuccess(response, file, fileList){
      if(response.status == 1000){
        this.getList();
        this.dialogFormVisible = false;
        this.appInfo = {};
      }else{
        this.$message.error(response.message);
      }
      this.$refs.uploadFile.clearFiles();
    },
    clear(){
      this.appInfo = {};
      
    },
    // 权限列表
    //一级操作全部按钮
    pmsItem0SelectAll(item0) {
      if (item0.childrenSelectedAll) {
        item0.children.forEach((item) => {
          if (item0.childrenSelected.indexOf(item.id) < 0) {
            item0.childrenSelected.push(item.id);
          }
        });
      } else {
        item0.childrenSelected.splice(0, item0.childrenSelected.length);
      }
    },
    // 一级操作单独功能
    pmsItem0ChildSelect(item0) {
      if (
        item0.childrenSelected.length == item0.children.length &&
        item0.children.length > 0
      ) {
        item0.childrenSelectedAll = true;
      } else if (
        item0.childrenSelected.length != item0.children.length &&
        item0.children.length > 0
      ) {
        item0.childrenSelectedAll = false;
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
.page_table_area.permission {
  .drawer_content {
    // width:1210px;
    margin-bottom: 100px;
    overflow: auto;
    position: absolute;
    top: 108px;
    left: 0;
    bottom: 0;
    right: 0;

    .name-kind_area {
      border: #CCD7EA solid 1px;

      .title {
        padding-left: 30px;
        height: 60px;
        font-size: 16px;
        background-color: #F1F4F9;
        line-height: 60px;
        font-weight: 500;
        border-bottom: #CCD7EA solid 1px;
      }

      .input {
        width: 220px;
      }

      .content {
        height: 80px;
        display: flex;
        flex-direction: row;
        align-items: center;

        .name, .kind {
          margin-left: 30px;
        }
        .name {
          margin-right:24px;
        }

        .units {
          height: 30px;
          line-height: 30px;
          font-size: 14px;
          color: #000;
        }
      }
      .el-checkbox {
        margin:0 10px;  
      }
    }

    .pms_area {
      border: #CCD7EA solid 1px;
      margin-top: 20px;

      .title {
        padding-left: 30px;
        height: 60px;
        font-size: 16px;
        background-color: #F1F4F9;
        line-height: 60px;
        font-weight: 500;
        border-bottom: #CCD7EA solid 1px;
      }

      .content {
        min-height: 80px;
        margin-left: 3rem;

        .pms_title {
          margin: 20px 10px 10px 0;
          font-size: 16px;
          color: #000;
          font-weight: 500;
          height: 22px;
          line-height: 22px;
        }

        .pms_page, .pms_sub, .pms_level0 {
          margin: 10px 10px 10px 0;
          color: #040300;
          font-size: 14px;
          // height: 20px;
          line-height: 20px;

          .left_title {
            margin-right:20px;
          }
        }

        // .pms_sub {
        // margin: 10px 10px 10px 0;
        // }
        .checkbox_all {
          margin-right: 30px;
        }
      }

      .remarks {
        margin: 20px 86px 70px 30px;

        .remarks_title {
          margin: 20px 10px 10px 0;
          font-size: 16px;
          color: #000;
          font-weight: 500;
          height: 22px;
          line-height: 22px;
        }
        .remarkLength {
          line-height:40px;
        }
      }

      .el-checkbox-group {
        display: inline-block;
        margin-right: 30px;
      }
    }
  }
  // 单选多选
    .el-radio ,.el-checkbox{
        color: #000000;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/PartI/AppManage/components/appTable.vue